// src/theme.js
export const theme = {
  colors: {
    // Spring-inspired color palette
    primary: {
      light: '#e8f5e9', // Light leaf green
      main: '#4caf50',  // Fresh spring green
      dark: '#2e7d32',  // Deep forest green
    },
    secondary: {
      light: '#f8f1e9', // Soft cherry blossom
      main: '#ffab91',  // Muted coral
      accent: '#ff6e40', // Vibrant accent for important actions
    },
    neutral: {
      white: '#ffffff',
      offWhite: '#f9f9f7', // Soft paper white
      lightGray: '#f1f1f1',
      gray: '#9e9e9e',
      darkGray: '#424242',
      black: '#1a1a1a',
    },
    status: {
      success: '#43a047', // Healthy green
      warning: '#ff9800', // Amber warning
      danger: '#e53935',  // Alert red
      info: '#42a5f5',    // Info blue
    },
    background: {
      main: '#f9f9f7',    // Soft off-white
      card: '#ffffff',    // White card backgrounds
      highlight: '#f0f7ee', // Very light green highlight
    }
  },
  shadows: {
    card: '0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.07)',
    cardHover: '0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.12)',
    modal: '0 10px 20px rgba(0,0,0,0.1), 0 6px 6px rgba(0,0,0,0.1)',
  },
  transitions: {
    standard: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  border: {
    radius: '8px',
    thin: '1px solid rgba(0,0,0,0.08)',
  }
};